// siteContent.js — the public website's wording, drawn from the existing
// kronigsupply.com.au. Contact details, the ABN and the logo come from
// Company Settings instead (GET /api/site/profile), so they're edited
// there, not here.

// The website's one address. Every public page names it as its canonical
// address, and once kronigsupply.com.au serves Optim, Optim's other
// addresses redirect here (see index.js). Also in public/robots.txt and
// public/sitemap.xml.
export const SITE_ORIGIN = 'https://kronigsupply.com.au';

export const HOME = {
  eyebrow: 'Importer & distributor · Australia & New Zealand',
  headline: 'We import and distribute specialist audio connectivity solutions.',
  intro: 'Kronig Supply curates niche audio connectors and cables from specialist manufacturers around the world — products you won’t find on every shelf — and imports and distributes them to the retailers and installers who serve the Pro Audio and Musical Instrument markets across Australia and New Zealand.',
  facts: [
    { label: 'We are', value: 'Importer & distributor' },
    { label: 'Our range', value: 'Curated, niche products' },
    { label: 'We supply', value: 'Retailers, installers & trade' },
    { label: 'Stock', value: 'Held locally in Sydney' },
    { label: 'Delivery', value: 'Australia Post, tracked' },
  ],
  pillars: [
    {
      title: 'We curate',
      body: 'We seek out niche products from specialist manufacturers around the globe — innovative, high-quality, and solving a real-world problem. A deliberately small range, chosen with care.',
    },
    {
      title: 'We import',
      body: 'We bring that range to Australia and New Zealand and hold it in Sydney, using a combination of picking facilities and long-term warehousing, so orders ship from local shelves.',
    },
    {
      title: 'We distribute',
      body: 'We supply retailers, installers and trade customers nationally, shipping with Australia Post for its reliability, coverage and tracking.',
    },
  ],
  brandsIntro: 'A curated set of niche brands we import and distribute in Australia and New Zealand — each chosen because it does something the mainstream doesn’t.',
  cta: {
    title: 'Retailer or installer? Become a stockist.',
    body: 'Tell us about your business. If we’re a good fit, we’ll send you our Trading Account Application.',
  },
};

export const ABOUT = {
  eyebrow: 'About us',
  headline: 'Family-owned. Built on the DNA of music.',
  lead: 'We started as musicians’ retailers, and that’s still who we are. Since 2021, we have imported and distributed high-quality audio products across Australia and New Zealand — partnering with like-minded manufacturers around the globe, and dealing fairly with everyone we work with.',
  storyTitle: 'How did we get here?',
  story: [
    'Back in 2019, we decided to create a family business in the world of music. We first created Kronig Music — an online store bringing guitar accessories to musicians.',
    'There was just one problem: too much competition. Despite the lack of a good local music store, over time it felt like we discovered a new competitor almost every day.',
    'As they say, there’s no such thing as problems — just opportunities. So we set about turning our competitors into our customers.',
    'In 2021 we formed Kronig Supply with the same family-owned, fair-dealing philosophy, becoming an importer and distributor of niche audio connectors.',
  ],
  quote: {
    text: 'As a music industry retailer, we discovered a new competitor almost every day. Why not turn our competitors into our customers and become their importer and distributor?',
    name: 'David Walker',
    role: 'Business Development Manager',
  },
  partnersTitle: 'Our partners',
  partnersIntro: 'Finding strategic partners is no easy task. We look for two things.',
  partnerCriteria: [
    { title: 'The products', body: 'Innovative, high-quality, and actually solving a real-world problem.' },
    { title: 'The people', body: 'Customer-focussed, honest and transparent, committed to quality and to an ethical work environment.' },
  ],
};

export const CONTACT = {
  eyebrow: 'Contact',
  headline: 'Have a question? Contact us.',
  lead: 'Send us a message, or reach out by phone or email, and we’ll be happy to help.',
  locationNote: 'We’re online only, so we can’t welcome visitors in person just yet.',
  formTitle: 'Send us a message',
  thanksTitle: 'Thanks, we’ve got your message.',
  thanksBody: 'We’ll get back to you soon. A confirmation is on its way to {email}.',
  tradeTitle: 'Trade enquiry',
  tradeBody: 'Retailers and installers: tell us about your business — its name and ABN, a contact person, and what you’re looking to stock. If we’re a good fit, we’ll send you our Trading Account Application.',
};

// What search engines show under each page's title.
export const PAGE_DESCRIPTIONS = {
  home: 'Kronig Supply imports and distributes curated, niche audio connectivity solutions — connectors and cables — for retailers and installers across Australia and New Zealand.',
  brands: 'The niche audio brands Kronig Supply imports and distributes across Australia and New Zealand, each chosen because it does something the mainstream doesn’t.',
  about: 'Family-owned and built on the DNA of music: how Kronig Supply became an importer and distributor of niche audio connectivity.',
  tradeEnquiry: 'Retailer or installer in Australia or New Zealand? Send Kronig Supply a trade enquiry to become a stockist of our curated range of audio connectors and cables.',
  contact: 'Contact Kronig Supply with a question about our audio connectors and cables, or send a trade enquiry to become a stockist.',
  privacy: 'How Kronig Supply handles personal information, under the Privacy Act 1988 and the Australian Privacy Principles.',
  terms: 'The terms of use for the Kronig Supply website, Customer portal and business systems.',
  quickbooksDisconnected: 'QuickBooks has been disconnected from Optim.',
  application: 'Complete and sign your Kronig Supply account application online.',
};
